type Listener = (conversationIds: ReadonlySet<string> | null) => void;
type Entry = {
  listeners: Set<Listener>;
  pending: Set<string>;
  all: boolean;
  timer?: ReturnType<typeof setTimeout>;
};
const viewers = new Map<string, Entry>();

/** Metadata-only invalidation; each mounted pager belongs to one current viewer. */
export function subscribeConversationChanges(viewerId: string, listener: Listener) {
  let entry = viewers.get(viewerId);
  if (!entry) {
    entry = { listeners: new Set(), pending: new Set(), all: false };
    viewers.set(viewerId, entry);
  }
  entry.listeners.add(listener);
  return () => {
    entry!.listeners.delete(listener);
    if (!entry!.listeners.size && viewers.get(viewerId) === entry) {
      clearTimeout(entry!.timer);
      viewers.delete(viewerId);
    }
  };
}

/** A burst produces one invalidation, and inactive pages create no request or retained event. */
export function invalidateConversations(viewerId: string, conversationId?: string) {
  const entry = viewers.get(viewerId);
  if (!entry) return;
  if (conversationId && !entry.all) entry.pending.add(conversationId);
  else entry.all = true;
  if (entry.pending.size > 100) {
    entry.all = true;
    entry.pending.clear();
  }
  if (entry.timer !== undefined) return;
  entry.timer = setTimeout(() => {
    entry.timer = undefined;
    if (viewers.get(viewerId) !== entry) return;
    const changed = entry.all ? null : new Set(entry.pending);
    entry.all = false;
    entry.pending.clear();
    for (const listener of entry.listeners) listener(changed);
  }, 100);
}
